/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PutTournamentsIdMutationRequest,
  PutTournamentsIdMutationResponse,
  PutTournamentsIdPathParams,
  PutTournamentsId400,
  PutTournamentsId401,
  PutTournamentsId403,
  PutTournamentsId404,
  PutTournamentsId500,
} from "../types/PutTournamentsId.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const putTournamentsIdMutationKey = () =>
  [{ url: "/tournaments/:id" }] as const;

export type PutTournamentsIdMutationKey = ReturnType<
  typeof putTournamentsIdMutationKey
>;

/**
 * {@link /tournaments/:id}
 */
export async function putTournamentsId(
  id: PutTournamentsIdPathParams["id"],
  data: PutTournamentsIdMutationRequest,
  config: Partial<RequestConfig<PutTournamentsIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutTournamentsIdMutationResponse,
    ResponseErrorConfig<
      | PutTournamentsId400
      | PutTournamentsId401
      | PutTournamentsId403
      | PutTournamentsId404
      | PutTournamentsId500
    >,
    PutTournamentsIdMutationRequest
  >({
    method: "PUT",
    url: `/tournaments/${id}`,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}

export function putTournamentsIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutTournamentsIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putTournamentsIdMutationKey();
  return mutationOptions<
    ResponseConfig<PutTournamentsIdMutationResponse>,
    ResponseErrorConfig<
      | PutTournamentsId400
      | PutTournamentsId401
      | PutTournamentsId403
      | PutTournamentsId404
      | PutTournamentsId500
    >,
    {
      id: PutTournamentsIdPathParams["id"];
      data: PutTournamentsIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putTournamentsId(id, data, config);
    },
  });
}

/**
 * {@link /tournaments/:id}
 */
export function usePutTournamentsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PutTournamentsIdMutationResponse>,
      ResponseErrorConfig<
        | PutTournamentsId400
        | PutTournamentsId401
        | PutTournamentsId403
        | PutTournamentsId404
        | PutTournamentsId500
      >,
      {
        id: PutTournamentsIdPathParams["id"];
        data: PutTournamentsIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutTournamentsIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putTournamentsIdMutationKey();

  const baseOptions = putTournamentsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PutTournamentsIdMutationResponse>,
    ResponseErrorConfig<
      | PutTournamentsId400
      | PutTournamentsId401
      | PutTournamentsId403
      | PutTournamentsId404
      | PutTournamentsId500
    >,
    {
      id: PutTournamentsIdPathParams["id"];
      data: PutTournamentsIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<PutTournamentsIdMutationResponse>,
    ResponseErrorConfig<
      | PutTournamentsId400
      | PutTournamentsId401
      | PutTournamentsId403
      | PutTournamentsId404
      | PutTournamentsId500
    >,
    {
      id: PutTournamentsIdPathParams["id"];
      data: PutTournamentsIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PutTournamentsIdMutationResponse>,
    ResponseErrorConfig<
      | PutTournamentsId400
      | PutTournamentsId401
      | PutTournamentsId403
      | PutTournamentsId404
      | PutTournamentsId500
    >,
    {
      id: PutTournamentsIdPathParams["id"];
      data: PutTournamentsIdMutationRequest;
    },
    TContext
  >;
}
